// --- START PATCH: PublicAuthRoute (redirect authenticated users away from /login & /signup) ---
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";

/**
 * PublicAuthRoute
 * Wrap public-only auth pages. If user is already authenticated,
 * redirect to /account/profile (your chosen destination).
 */
const PublicAuthRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-24">
        <div className="h-4 w-40 bg-muted animate-pulse rounded" />
      </div>
    );
  }

  if (user) {
    // Already logged in – send to profile (chosen option #3 earlier)
    return <Navigate to="/account/profile" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PublicAuthRoute;
// --- END PATCH: PublicAuthRoute (redirect authenticated users away from /login & /signup) ---